module.exports = __webpack_public_path__ + "static/media/lorelai-miss-2.efac0570.wav";